/**
 * Merges cached and freshly fetched UUID pairs, restricted to the current users.
 *
 * Only current users are kept (users deleted upstream drop out) and only truthy UUIDs are included
 * (unmapped ids are skipped). Cached values take precedence — being immutable, they are equal anyway.
 *
 * @param {Array<{PK_User: string|number}>} usersList - Current account users.
 * @param {Object} cachedPairs - PK_User → UUID already cached.
 * @param {Object} freshPairs - PK_User → UUID just fetched (may contain nulls).
 * @returns {Object} PK_User → UUID for current users that have a known UUID.
 */
export const mergeUsersUuids = (usersList, cachedPairs, freshPairs) => {
    const merged = {};
    usersList.forEach((user) => {
        const pk = String(user.PK_User);
        const uuid = cachedPairs[pk] || freshPairs[pk];
        if (uuid) {
            merged[pk] = uuid;
        }
    });

    return merged;
};
